module.exports = __webpack_public_path__ + "static/autoscan-f7691b01a9974a5a579ff59b2a6a16ef.jpg";